import { first } from "@ckeditor/ckeditor5-utils";

/**
 * Downcast: modelo → vista
 * Convierte el atributo `recorderStyle` en una clase CSS aplicada al widget.
 */
export function modelToViewStyleAttribute(styles) {
    return (evt, data, conversionApi) => {
        if (!conversionApi.consumable.consume(data.item, evt.name)) {
            return;
        }

        const newStyle = getStyleDefinitionByName(data.attributeNewValue, styles);
        const oldStyle = getStyleDefinitionByName(data.attributeOldValue, styles);
        const viewElement = conversionApi.mapper.toViewElement(data.item);
        const viewWriter = conversionApi.writer;

        if (oldStyle) {
            viewWriter.removeClass(oldStyle.className, viewElement);
        }
        if (newStyle) {
            viewWriter.addClass(newStyle.className, viewElement);
        }
    };
}

/**
 * Upcast: vista → modelo
 * Detecta clases de alineación en la vista y las guarda en el atributo `recorderStyle`.
 */
export function viewToModelStyleAttribute(styles) {
    const nonDefaultStyles = {
        recorderInline: styles.filter(
            style => !style.isDefault && style.modelElements.includes("recorderInline")
        ),
        recorderBlock: styles.filter(
            style => !style.isDefault && style.modelElements.includes("recorderBlock")
        ),
    };

    return (evt, data, conversionApi) => {
        if (!data.modelRange) {
            return;
        }

        const viewElement = data.viewItem;
        const modelRecorderElement = first(data.modelRange.getItems());
        if (!modelRecorderElement) {
            return;
        }

        if (nonDefaultStyles[modelRecorderElement.name]) {
            for (const style of nonDefaultStyles[modelRecorderElement.name]) {
                if (
                    style &&
                    conversionApi.consumable.consume(viewElement, {
                        classes: style.className,
                    })
                ) {
                    conversionApi.writer.setAttribute(
                        "recorderStyle",
                        style.name,
                        modelRecorderElement
                    );
                }
            }
        }
    };
}

/**
 * Utilidad: busca un estilo por nombre.
 */
function getStyleDefinitionByName(name, styles) {
    for (const style of styles) {
        if (style.name === name) {
            return style;
        }
    }
}
